import React from 'react';
import { Link } from '@/Framework/Router/Next/Link';

interface IProps {
  text: string,
  linkTo: string,
  linkTitle: string,
}

const EmptyMessageWithLink = ({ text, linkTo, linkTitle }: IProps) => (
  <p>
    { text }&nbsp;
    <Link target="_blank" to={ linkTo }>
      { linkTitle }
    </Link>.
  </p>
);

export default EmptyMessageWithLink;
